import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { builtInToolName } from "../../../api/content/processDefinitions";
import { getItemVersion } from "../../../api/content/itemsApi";
import { useLoad } from "../../../shared/loading/useLoad";
import SourceView from "../../../ui/content/source/SourceView";

/**
 * What the tool a step ran does, and its code, from the tool's item as reviewed (F67: "a
 * small description of the tool that was used"). A built-in tool has no item to read.
 */
export default function ToolAbout({ tool }: { tool: string }) {
  return builtInToolName(tool) === null ? <ItemToolAbout tool={tool} /> : null;
}

function ItemToolAbout({ tool }: { tool: string }) {
  const { t } = useTranslation();
  const load = useCallback((signal: AbortSignal) => getItemVersion(tool, signal), [tool]);
  const { state } = useLoad(load);
  if (state.status !== "loaded") return null;
  const definition = state.value.definition;
  const description = state.value.description ?? (typeof definition?.["description"] === "string" ? definition["description"] : "");
  const code = typeof definition?.["code"] === "string" ? definition["code"] : null;
  return (
    <div className="space-y-1 text-xs">
      {description === "" ? null : <p className="app-text-muted">{description}</p>}
      {code === null ? null : (
        <details>
          <summary className="app-link cursor-pointer text-[11px]">{t("threads.toolStep.code")}</summary>
          <SourceView label={t("threads.toolStep.codeOf", { tool: state.value.name })} language="plaintext" value={code} className="mt-1" />
        </details>
      )}
    </div>
  );
}
